<ix-key-value-list>
  <ix-key-value
    [label]="
          'battery_pass.edit.attribute_assignments_pane.assignee' | translate
        "
    [value]="assignmentPaneData?.assigneeEmail"
    labelPosition="left"
  ></ix-key-value>
  <ix-key-value
    [label]="'battery_pass.edit.attribute_assignments_pane.assignment_date' | translate"
    labelPosition="left"
    value="-"
  ></ix-key-value>
  <ix-key-value
    [label]="
          'battery_pass.edit.attribute_assignments_pane.attribute' | translate
        "
    [value]="assignmentPaneData?.attributeLabel ?? '' | translate"
    labelPosition="left"
  ></ix-key-value>
  <ix-key-value
    [label]="
          'battery_pass.edit.attribute_assignments_pane.status' | translate
        "
    [value]="assignmentPaneData?.status"
    labelPosition="left"
  ></ix-key-value>
</ix-key-value-list>
<div class="d-flex mt-3 mb-5 justify-content-end gap-1">
  <ix-button
    (click)="onRemoveAssignmentClick()"
    onkeypress=""
    variant="danger-secondary"
    >
    {{
    'battery_pass.edit.attribute_assignments_pane.remove_assignment'
    | translate
    }}
  </ix-button>
  @if (assignmentPaneData?.status !== 'complete') {
    <ix-button
      (click)="onRemindAssignmentClick()"
      [disabled]="assignmentPaneData?.id === null"
      onkeypress=""
      variant="secondary"
      >{{
      'battery_pass.edit.attribute_assignments_pane.re_request_data'
      | translate
      }}
    </ix-button>
  }
</div>
